import { route } from "../utils";
import { RouteType } from "../types";
import UsersPage from "@/pages/user-page";
import CreateUserPage from "@/pages/users/create-user-page";
import UserViewPage from "@/pages/users/view-user-page";
import EditUserPage from "@/pages/users/edit-user-page";
export const userRoutes: Record<string, RouteType> = {
    list: route("/users", UsersPage),
    new: route("/users/new", CreateUserPage),
    view: route("/users/:id", UserViewPage),
    edit: route("/users/:id/edit", EditUserPage),
};
